"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgSearchPage = exports.OrgSearchConfig = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var icon_1 = require("../components/icon");
var icons_1 = require("../components/icon/icons");
var table_1 = require("../components/table/table");
var theme_1 = require("../components/theme");
var i18n_1 = require("../i18n");
var mithril_1 = require("../mithril");
var services_1 = require("../services");
var org_search_style_1 = require("./org.search.style");
var page_1 = require("./page");
(0, theme_1.addStyles)(org_search_style_1.Style);
exports.OrgSearchConfig = {
    type: 'internal',
    name: page_1.IkePageName.orgSearch,
    path: '/org/search',
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.ORG_SEARCH_PAGE]
    },
    nav: {
        name: i18n_1.T.ORG_SEARCH,
        icon: icons_1.MaterialIcon.ORG_SEARCH
    }
};
var OrgSearchPage = /** @class */ (function (_super) {
    tslib_1.__extends(OrgSearchPage, _super);
    function OrgSearchPage() {
        var _this = _super.call(this, exports.OrgSearchConfig) || this;
        _this.rows = [];
        _this.timer = null;
        _this.searchResponse = null;
        _this.searchQuery = null;
        return _this;
    }
    OrgSearchPage.prototype.viewPole = function (primary, secondary, department, index) {
        return [
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, String(index)),
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, "".concat(primary == null ? (0, i18n_1.Translate)(i18n_1.T.EMPTY) : primary)),
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, "".concat(secondary == null ? (0, i18n_1.Translate)(i18n_1.T.EMPTY) : secondary)),
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, "".concat(department == null ? (0, i18n_1.Translate)(i18n_1.T.EMPTY) : department))
        ];
    };
    OrgSearchPage.prototype.viewPoles = function () {
        var _this = this;
        var headers = ['#', 'Primary', 'Secondary', 'Department'];
        while (this.rows.length > 0) {
            this.rows.pop();
        }
        var results = this.searchResponse;
        if (results != null && this.searchQuery != null) {
            var count_1 = 0;
            results.forEach(function (el) {
                count_1++;
                _this.rows.push(_this.viewPole(el.primary, el.secondary, el.departmentName, count_1));
            });
        }
        if (this.rows.length > 0) { //results
            return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.SEARCH_RES), headers, this.rows);
        }
        else if (this.searchQuery != null) { //query but no results
            return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.TAG_FILTER__SEARCH_EMPTY), [], this.rows);
        }
        else {
            return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.INPUT_REQUIRED), [], this.rows);
        }
    };
    OrgSearchPage.prototype.sendQ = function (str) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(str === '' || str == null)) return [3 /*break*/, 1];
                        this.searchResponse = null;
                        this.searchQuery = null;
                        return [3 /*break*/, 3];
                    case 1:
                        this.searchQuery = str;
                        _a = this;
                        return [4 /*yield*/, services_1.Services.SearchOrg.sendQuery(this.searchQuery)];
                    case 2:
                        _a.searchResponse = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, true];
                }
            });
        });
    };
    OrgSearchPage.prototype.onChange = function (e) {
        var _this = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function (val) {
            _this.sendQ(val);
        }, 300, e.target.value);
    };
    Object.defineProperty(OrgSearchPage.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (!services_1.Services.User.hasUser) {
                services_1.Services.User.logout();
                return null;
            }
            if (!services_1.Services.Token.has(core_api_1.IkeToken.ORG_SEARCH_PAGE) && !services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
                var lockedOut = (0, mithril_1.m)('div', { className: 'container' }, [
                    (0, mithril_1.m)('span', { className: 'title' }, 'No Organization Search Feature Token')
                ]);
                return lockedOut;
            }
            var icon = icon_1.Icon.view(icons_1.MaterialIcon.ORG_SEARCH, { className: org_search_style_1.CSS.box.icon });
            var children = [
                (0, mithril_1.m)('header', { className: org_search_style_1.CSS.search.container }, [
                    (0, mithril_1.m)('div', { className: org_search_style_1.CSS.search.row }, [
                        (0, mithril_1.m)('div', { className: org_search_style_1.CSS.search.section }, [
                            (0, mithril_1.m)('span', { className: 'title' }, (0, i18n_1.Translate)(i18n_1.T.ORG_SEARCH))
                        ]),
                        (0, mithril_1.m)('div', { className: org_search_style_1.CSS.box.container }, [
                            icon,
                            (0, mithril_1.m)('input', {
                                className: org_search_style_1.CSS.box.input,
                                type: 'text',
                                placeholder: 'search by secondary or primary field',
                                oninput: function (e) { return _this.onChange(e); }
                            })
                        ]),
                        (0, mithril_1.m)('div', { className: "".concat(org_search_style_1.CSS.search.section, " ").concat(org_search_style_1.CSS.search.sectionRight) })
                    ])
                ]),
                (0, mithril_1.m)('div', { className: 'results' }, [
                    this.viewPoles()
                ])
            ];
            var nodes = (0, mithril_1.m)('div', { className: 'container' }, children);
            return nodes;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], OrgSearchPage.prototype, "searchResponse", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], OrgSearchPage.prototype, "searchQuery", void 0);
    return OrgSearchPage;
}(page_1.IkePage));
exports.OrgSearchPage = OrgSearchPage;
//# sourceMappingURL=org.search.page.js.map